import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  activeNotifications: {
    filteredTotal: 0,
    notifications: [],
    subscriptions: [],
    available_categories: [],
  },
  resolvedNotifications: {
    filteredTotal: 0,
    notifications: [],
    subscriptions: [],
    available_categories: [],
  },
  selectedSubscriptionCategory: undefined,
  selectedAdminId: undefined,
  selectedNotification: undefined,
  isSubscriptionCategoryModalVisible: false,
  isAssignAdminModalVisible: false,
  loading: false,
  isAdminsFetching: false,
  isTopNavNotificationsLoading: false,
  total: 0,
  filteredTotal: 0,
  selectedRowKeys: [],
  administrators: [],
  notifications: [],
};

function onLoadTopNavNotificationsRequest(state) {
  return {
    ...state,
    isTopNavNotificationsLoading: true,
  };
}

function onLoadTopNavNotificationsSuccess(state, { payload }) {
  return {
    ...state,
    notifications: payload.notifications,
    isTopNavNotificationsLoading: false,
  };
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { records, total, filteredTotal, filters, tab, subscriptions, available_categories } = payload;

  const notifications =
    tab === 'active'
      ? { activeNotifications: { notifications: records, filteredTotal, subscriptions, available_categories } }
      : { resolvedNotifications: { notifications: records, filteredTotal, subscriptions, available_categories } };

  return {
    ...state,
    ...notifications,
    total,
    filters,
    loading: false,
  };
}

function onLoadAdministratorsRequest(state) {
  return {
    ...state,
    isAdminsFetching: true,
  };
}

function onLoadAdministratorsSuccess(state, { payload }) {
  const { administrators } = payload;

  return {
    ...state,
    administrators,
    isAdminsFetching: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function onChangeProperties(state, { payload }) {
  const { selectedRowKeys } = payload;

  return {
    ...state,
    selectedRowKeys,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;

  state[attr] = value;

  return {
    ...state,
    state: {
      ...state,
    },
  };
}

function onToggleSubscriptionCategoryModal(state, { payload }) {
  return {
    ...state,
    isSubscriptionCategoryModalVisible: payload,
  };
}

function onToggleAssignAdminModal(state, { payload }) {
  return {
    ...state,
    isAssignAdminModalVisible: payload,
  };
}

function onUnsubscribeSuccess(state) {
  return {
    ...state,
  };
}

function onSubscribe(state) {
  return {
    ...state,
    loading: true,
  };
}

function onSubscribeSuccess(state) {
  return {
    ...state,
    isSubscriptionCategoryModalVisible: false,
    selectedSubscriptionCategory: undefined,
    isAdminsFetching: false,
    loading: false,
  };
}

function onAssignRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onAssigneSuccess(state) {
  return {
    ...state,
    isAssignAdminModalVisible: false,
    selectedAdminId: undefined,
    selectedNotification: undefined,
    loading: false,
  };
}

function onUnassignRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onUnassigneSuccess(state) {
  return {
    ...state,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.ASSIGN_REQUEST]: onAssignRequest,
  [actions.ASSIGN_SUCCESS]: onAssigneSuccess,
  [actions.CHANGE_PROPERTIES]: onChangeProperties,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD_ADMINISTRATORS_REQUEST]: onLoadAdministratorsRequest,
  [actions.LOAD_ADMINISTRATORS_SUCCESS]: onLoadAdministratorsSuccess,
  [actions.LOAD_DATA_REQUEST]: onLoad,
  [actions.LOAD_DATA_SUCCESS]: onLoadSuccess,
  [actions.LOAD_TOP_NAV_NOTIFICATIONS_REQUEST]: onLoadTopNavNotificationsRequest,
  [actions.LOAD_TOP_NAV_NOTIFICATIONS_SUCCESS]: onLoadTopNavNotificationsSuccess,
  [actions.SUBSCRIBE]: onSubscribe,
  [actions.SUBSCRIBE_SUCCESS]: onSubscribeSuccess,
  [actions.TOGGLE_ASSIGN_ADMIN_MODAL]: onToggleAssignAdminModal,
  [actions.TOGGLE_SUBSCRIPTION_CATEGORY_MODAL]: onToggleSubscriptionCategoryModal,
  [actions.UNASSIGN_REQUEST]: onUnassignRequest,
  [actions.UNASSIGN_SUCCESS]: onUnassigneSuccess,
  [actions.UNSUBSCRIBE_SUCCESS]: onUnsubscribeSuccess,
});
